import { Sparkles, Check, ArrowRight } from "lucide-react";
import { Reveal, Overline, GlowOrb, CTA } from "./ui";
import { FREE_TIER_POINTS } from "./data";
import { getAppUrl } from "@/urls";

// Batch 136 — this was a waitlist. It collected a name and an email, POSTed
// them to /api/waitlist, and answered "we'll email you the moment your spot
// opens". Public signup shipped, so there was no spot and never would be: the
// product the visitor wanted was one click away while the page asked them to
// wait for it. Someone who submitted an address got nothing.
//
// It is now a way in, in the same slot, in the same card, at the same weight.
// One control, and it opens the app.
//
// The four chips changed with it. Lifetime founding-member pricing, priority
// access to every feature and a say in the roadmap were things offered FOR
// JOINING A LIST. With no list they are promises with no mechanism behind
// them, which is the same defect as the invite that never arrives. What is
// there now is what the product actually does, and the free-tier number comes
// from section 4 of the terms rather than from marketing.
//
// THE LEGAL LINE SURVIVES, reworded. Batch 135 put "By joining you confirm you
// are 18 or older and agree to our Terms" on the form, because the form
// submitted an address. Nothing is submitted here now, so claiming acceptance
// at the moment of a link click would be false. This states the age and points
// at both documents. The agree-versus-told split stays on the registration
// card, where an account is actually created.
export const Waitlist = () => (
  <section id="waitlist" className="relative py-24 md:py-32 overflow-hidden">
    <GlowOrb className="w-[500px] h-[500px] left-1/2 -translate-x-1/2 top-0 opacity-60" />
    <div className="relative max-w-2xl mx-auto px-6">
      <Reveal className="text-center mb-10">
        <Overline>Start free</Overline>
        <h2 className="mt-4 font-['Bebas_Neue'] text-4xl sm:text-5xl md:text-6xl text-[#F0F0F0] tracking-wide leading-none">
          Your next reply, <span className="text-[#C9A84C]">handled</span>
        </h2>
        <p className="mt-4 font-['Inter'] text-[#A8A8B8] text-base md:text-lg">
          Five replies free, in total, not five a day. No card, nothing to join.
        </p>
      </Reveal>

      <Reveal delay={0.05} className="mb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-xl mx-auto">
          {FREE_TIER_POINTS.map((p) => (
            <div key={p} className="flex items-center gap-2.5 rounded-xl bg-white/[0.03] border border-[#2A2A35] px-4 py-3">
              <span className="w-5 h-5 rounded-full bg-[#C9A84C]/15 flex items-center justify-center shrink-0">
                <Check size={12} className="text-[#C9A84C]" strokeWidth={3} />
              </span>
              <span className="text-[#D8D8E0] text-sm font-['Inter']">{p}</span>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="relative rounded-3xl bg-[#1A1A1F] border border-[#C9A84C]/30 p-7 md:p-10 shadow-[0_0_40px_rgba(201,168,76,0.1)] text-center">
          <h3 className="font-['Bebas_Neue'] text-3xl text-[#F0F0F0] tracking-wide">
            Paste the conversation. Get the move.
          </h3>
          <p className="mt-3 font-['Inter'] text-[#A8A8B8]">
            It reads the whole thread, not the last line.
          </p>
          <div className="mt-7 flex justify-center">
            <CTA href={getAppUrl()} testid="waitlist-cta">
              <Sparkles size={18} /> Open SparkCue <ArrowRight size={18} />
            </CTA>
          </div>
          {/* Batch 138 — the page never stated the price. A visitor learned it
              for the first time at reply six, on a paywall, having been told
              only that the product was free. The prices are terms.md section 4.
              Batch 140 — checkout shipped, so the availability clause went and
              the promise from section 4 took its place. Three surfaces said
              payments were closed and all three moved together, because
              shipping while any of them still said otherwise is the drift this
              run has been closing. */}
          <p className="mt-5 text-center text-[#7A7A8C] text-xs font-['Inter']" data-testid="waitlist-pricing">
            Five replies free, in total. After that it's $9.99 a month or $59.99 a year.
            Cancel any time.
          </p>
          <p className="mt-5 text-center text-[#7A7A8C] text-xs font-['Inter']" data-testid="waitlist-legal">
            Must be 18 or older. See our{" "}
            <a href="/terms" data-testid="waitlist-terms-link" className="underline hover:text-[#C9A84C] transition-colors">Terms</a>
            {" "}and{" "}
            <a href="/privacy" data-testid="waitlist-privacy-link" className="underline hover:text-[#C9A84C] transition-colors">Privacy Policy</a>.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
